"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeMatchingVehicleIds = exports.setMatchingVehicleIds = exports.REMOVE_MATCHING_VEHICLE_IDS = exports.SET_MATCHING_VEHICLE_IDS = exports.MATCHING_VEHICLES = void 0;
exports.MATCHING_VEHICLES = '[matching vehicle Ids]';
exports.SET_MATCHING_VEHICLE_IDS = `${exports.MATCHING_VEHICLES} SET`;
exports.REMOVE_MATCHING_VEHICLE_IDS = `${exports.MATCHING_VEHICLES} DELETE`;
const setMatchingVehicleIds = ({ vehicleIds }) => ({
    type: exports.SET_MATCHING_VEHICLE_IDS,
    payload: vehicleIds,
    meta: { feature: exports.MATCHING_VEHICLES },
});
exports.setMatchingVehicleIds = setMatchingVehicleIds;
const removeMatchingVehicleIds = () => ({
    type: exports.REMOVE_MATCHING_VEHICLE_IDS,
    payload: [],
    meta: { feature: exports.MATCHING_VEHICLES },
});
exports.removeMatchingVehicleIds = removeMatchingVehicleIds;
//# sourceMappingURL=matchingVehicles.js.map